import type { ReactNode } from 'react';

/** Shared chrome for the four public auth screens (§8.1). */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-[var(--bg)] px-4 py-10">
      <div className="w-full max-w-[380px]">
        <div className="mb-6 flex items-center gap-2">
          <span
            className="grid size-8 place-items-center rounded-[6px] text-[16px] font-bold text-[var(--accent-contrast)]"
            style={{ background: 'var(--accent)' }}
            aria-hidden
          >
            V
          </span>
          <span className="text-[17px] font-semibold">VirtueTasks</span>
        </div>

        <div className="vt-surface vt-elevated p-5">
          <h1 className="text-[20px] font-semibold">{title}</h1>
          {subtitle ? <p className="mb-4 mt-0.5 text-[13px] vt-muted">{subtitle}</p> : <div className="mb-4" />}
          {children}
        </div>

        {footer ? <div className="mt-4 text-center text-[12px] vt-muted">{footer}</div> : null}
      </div>
    </div>
  );
}
